import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPolicyData: null, // Stores complete policy details
  policyTypeId: null,
  insurerId: null,
  policyId: null,
  policyNumber: null,
};

const enrollmentPolicySlice = createSlice({
  name: "enrollmentPolicy",
  initialState,
  reducers: {
    setSelectedPolicyData: (state, action) => {
      const policyDetails = action.payload;
      state.selectedPolicyData = policyDetails;
      state.policyTypeId = policyDetails?.policy_type_id || null;
      state.insurerId = policyDetails?.policy_select_insurer_id || null;
      state.policyId = policyDetails?.policy_id || null;
      state.policyNumber = policyDetails?.policy_number || null;
    },
    clearSelectedPolicyData: (state) => {
      state.selectedPolicyData = null;
      state.policyTypeId = null;
      state.insurerId = null;
      state.policyId = null;
      state.policyNumber = null;
    },
  },
});

export const { setSelectedPolicyData, clearSelectedPolicyData } = enrollmentPolicySlice.actions;

// Selectors
export const selectSelectedPolicyData = (state) => state.enrollmentPolicy.selectedPolicyData;
export const selectPolicyTypeId = (state) => state.enrollmentPolicy.policyTypeId;
export const selectInsurerId = (state) => state.enrollmentPolicy.insurerId;
export const selectPolicyId = (state) => state.enrollmentPolicy.policyId;
export const selectPolicyNumber = (state) => state.enrollmentPolicy.policyNumber;

export default enrollmentPolicySlice.reducer;
